import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'login',
    meta: {
      requireLogin: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/authentication/Login.vue'),
    meta: {
      layout: 'blank',
      requireLogin: false
    },
  },
  // frontend/src/router/index.js - Add this route
  {
    path: '/security/lockouts',
    name: 'SecurityLockouts',
    component: () => import('@/views/authentication/SecurityLockouts.vue'),
    meta: { requireLogin: true }
  },
  {
    path: '/manager/topups',
    name: 'manager.topups',
    component: () => import('@/views/savings/manager/TopupManagement.vue'),
    meta: { requiresAuth: true, role: 'manager' }
  },
  {
    path: '/savings/manager/deposit-blocks',
    name: 'savings.manager.deposit_blocks',
    component: () => import('@/views/savings/manager/ManagerDepositBlocks.vue'),
    meta: {
      requireLogin: true,
    },
  },
  {
    path: '/savings/manager/topup-accounts',
    name: 'savings.manager.topup_accounts',
    component: () => import('@/views/savings/manager/TopupAccountManagement.vue'),
    meta: { requireLogin: true },
  },



  {
    path: '/savings/dashboard',
    name: 'savings.dashboard',
    component: () => import('@/views/savings/dashboard/Dashboard.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/dashboard',
    name: 'marketplace.dashboard',
    component: () => import('@/views/marketplace/dashboard/Dashboard.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/njangi/dashboard',
    name: 'njangi.dashboard',
    component: () => import('@/views/njangi/dashboard/Dashboard.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/fundraising/dashboard',
    name: 'fundraising.dashboard',
    component: () => import('@/views/fundraising/dashboard/Dashboard.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/monitor/dashboard',
    name: 'monitor.dashboard',
    component: () => import('@/views/monitor/dashboard/Dashboard.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/kyc-manager',
    name: 'savings.kyc_manager',
    component: () => import('@/views/savings/kyc/KYCManager.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/deposit_requests',
    name: 'savings.deposit_requests',
    component: () => import('@/views/savings/deposit/Requests.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/sms_validations',
    name: 'savings.sms_validations',
    redirect: { name: 'savings.paiements_auto_validations' },
  },
  {
    path: '/savings/paiements/validations-auto',
    name: 'savings.paiements_auto_validations',
    component: () => import('@/views/savings/paiements/SmsAutoValidationsMonitor.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: "/savings/payment-history",
    name: "savings.payment_history",
    component: () => import("@/views/savings/paiements/PaymentHistory.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: '/savings/deposit_transactions',
    name: 'savings.deposit_transactions',
    component: () => import('@/views/savings/deposit/DepositTransactions.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/make_deposits',
    name: 'savings.make_deposits',
    component: () => import('@/views/savings/deposit/MakeDeposit.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/partnership/requests',
    name: 'savings.partnership_requests',
    component: () => import('@/views/savings/partners/PartnershipRequests.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/Make_Withdraw',
    name: 'savings.partnership_Make_Withdraw',
    component: () => import('@/views/savings/partners/MakeMarketerWithdraw.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/requests_withdraw',
    name: 'savings.partnership_requests_withdraw',
    component: () => import('@/views/savings/partners/WithdrawRequestsMarketer.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/withdrawal_transactions',
    name: 'savings.partnership_withdrawal_transactions',
    component: () => import('@/views/savings/partners/WithdrawalTransactions.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/transactions',
    name: 'savings.clients_transactions',
    component: () => import('@/views/savings/clients/UserTransactions.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/clients',
    name: 'savings.partners_clients',
    component: () => import('@/views/savings/partners/PartnersClients.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/new_partner',
    name: 'savings.new_partner',
    component: () => import('@/views/savings/partners/NewPartner.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/partnership/repair-relations',
    name: 'savings.RepairRelations',
    component: () => import('@/views/savings/partners/RepairRelations.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/requests',
    name: 'savings.business_requests',
    component: () => import('@/views/savings/business_suite/BusinessRequests.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/clients',
    name: 'savings.business_clients',
    component: () => import('@/views/savings/business_suite/BusinessClients.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/AddBusinessVideos',
    name: 'savings.business_AddBusinessVideos',
    component: () => import('@/views/savings/business_suite/AddBusinessVideos.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/BussinessTransactions',
    name: 'savings.business_BussinessTransactions',
    component: () => import('@/views/savings/business_suite/BussinessTransactions.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/videos',
    name: 'savings.business_videos',
    component: () => import('@/views/savings/business_suite/BusinessVideos.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/commissions',
    name: 'savings.business_commissions',
    component: () => import('@/views/savings/business_suite/BusinessCommissions.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/chatbot/videos',
    name: 'manager.chatbot_videos',
    component: () => import('@/views/chatbot/ChatbotVideos.vue'),
    meta: {
      requireLogin: true,
      title: 'Manager: Chatbot AI Videos',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Chatbot Videos', active: true }
      ]
    }
  },
  {
    path: '/chatbot/videos/add',
    name: 'manager.add_chatbot_video',
    component: () => import('@/views/chatbot/AddChatbotVideo.vue'),
    meta: {
      requireLogin: true,
      title: 'Manager: Add Chatbot Video',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Chatbot Videos', to: '/chatbot/videos' },
        { text: 'Add Video', active: true }
      ]
    }
  },
  {
    path: '/chatbot/videos/edit/:id',
    name: 'manager.edit_chatbot_video',
    component: () => import('@/views/chatbot/AddChatbotVideo.vue'),
    meta: {
      requireLogin: true,
      title: 'Manager: Edit Chatbot Video',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Chatbot Videos', to: '/chatbot/videos' },
        { text: 'Edit Video', active: true }
      ]
    }
  },
  {
    path: '/savings/business-suite/list',
    name: 'manager.business_suite.list',
    component: () => import('@/views/savings/business_suite/BusinessSuiteList.vue'),
    meta: {
      title: 'Manager: Business Suite',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Business Suite', active: true }
      ]
    }
  },
  {
    path: '/savings/business-suite/detail/:id',
    name: 'manager.business_suite.detail',
    component: () => import('@/views/savings/business_suite/BusinessSuiteDetail.vue'),
    meta: {
      title: 'Manager: Business Suite Details',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Business Suite', to: '/savings/business-suite/list' },
        { text: 'Detail', active: true }
      ]
    }
  },

  {
    path: '/commissions/manager-overview',
    name: 'savings.business_manager_commissions',
    component: () => import('@/views/savings/business_suite/ManagerCommissionsOverview.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/new_partner',
    name: 'savings.new_business',
    component: () => import('@/views/savings/business_suite/NewClient.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/BusinessManagement',
    name: 'savings.BusinessManagement',
    component: () => import('@/views/savings/business_suite/BusinessManagement.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/Business/BusinessSetting',
    name: 'savings.BusinessSetting',
    component: () => import('@/views/savings/business_suite/BusinessSetting.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/make_withdrawals',
    name: 'savings.make_withdrawals',
    component: () => import('@/views/savings/withdrawal/MakeWithdrawal.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/request_withdrawal',
    name: 'savings.request_withdrawal',
    component: () => import('@/views/savings/withdrawal/RequestWithdrawal.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/withdrawal_requests',
    name: 'savings.withdrawal_requests',
    component: () => import('@/views/savings/withdrawal/Requests.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/savings/withdrawal_transactions',
    name: 'savings.withdrawal_transactions',
    component: () => import('@/views/savings/withdrawal/WithdrawalTransactions.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/make_interrupt',
    name: 'savings.make_interrupt',
    component: () => import('@/views/savings/interrupt/MakeInterrupt.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/savings/interrupt_requests',
    name: 'savings.interrupt_requests',
    component: () => import('@/views/savings/interrupt/Requests.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/interrupt_transactions',
    name: 'savings.interrupt_transactions',
    component: () => import('@/views/savings/interrupt/InterruptTransactions.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/profile/account-settings/:client_id',
    name: 'savings.profile-account-settings:client_id',
    component: () => import('@/views/savings/clients/account-settings/AccountSettings.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/summary',
    name: 'savings.clients',
    component: () => import('@/views/savings/clients/ClientList.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/savings/clients/campaign/:id',
    name: 'savings.client_campaign:id',
    component: () => import('@/views/savings/clients/CampaignDetail.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/loan/:id',
    name: 'savings.client_loan:id',
    component: () => import('@/views/savings/clients/LoanDetail.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/create',
    name: 'savings.create_client',
    component: () => import('@/views/savings/clients/CreateClient.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/create_campaign',
    name: 'savings.clients_create_campaign',
    component: () => import('@/views/savings/clients/CreateCampaign.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/savings/clients/zones',
    name: 'savings.clients_zones',
    component: () => import('@/views/savings/clients/TopUpZones.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/create_zone',
    name: 'savings.clients_create_zone',
    component: () => import('@/views/savings/clients/CreateZone.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/campaigns',
    name: 'savings.clients_campaigns',
    component: () => import('@/views/savings/clients/Campaigns.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/loans',
    name: 'savings.clients_loans',
    component: () => import('@/views/savings/clients/Loans.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/old/loans',
    name: 'savings.clients_Old_loans',
    component: () => import('@/views/savings/clients/OldLoans.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/create_loan',
    name: 'savings.clients_create_loan',
    component: () => import('@/views/savings/clients/CreateLoan.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/clients/insert_client_to_zone/',
    name: 'savings.insert_client',
    component: () => import('@/views/savings/clients/InsertClientToZone.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/clients/credits',
    name: 'savings.credits',
    component: () => import('@/views/savings/clients/ManageUserCredits.vue'),
    meta: { requiresAdmin: true }
  },

  {
    path: '/savings/clients/delete_client_from_zone/',
    name: 'savings.delete_client',
    component: () => import('@/views/savings/clients/DeleteClientFromZone.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/summary',
    name: 'savings.topup_summary',
    component: () => import('@/views/savings/topups/Partners.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/create',
    name: 'savings.topup_create',
    component: () => import('@/views/savings/topups/CreateTopUp.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/requested_password',
    name: 'savings.topup_requested_password',
    component: () => import('@/views/savings/topups/ResetPasswordRequests.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/change_password/:topup_request_id',
    name: 'savings.topup_change_password:topup_request_id',
    component: () => import('@/views/savings/topups/ResetPasswordForm.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/recharge',
    name: 'savings.topup_recharge',
    component: () => import('@/views/savings/topups/Recharge.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/transactions',
    name: 'savings.topup_transactions',
    component: () => import('@/views/savings/topups/Transactions.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/faults',
    name: 'savings.topup_faults',
    component: () => import('@/views/savings/topups/Faults.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/topup/faults/create',
    name: 'savings.topup_create_fault',
    component: () => import('@/views/savings/topups/CreateFault.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/investments',
    name: 'savings.investments',
    component: () => import('@/views/savings/investments/InvestmentsList.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/investments/create',
    name: 'savings.create_investment',
    component: () => import('@/views/savings/investments/CreateInvestment.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/savings/salaries',
    name: 'savings.salaries',
    component: () => import('@/views/savings/salaries/SalaryList.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/salaries/create',
    name: 'savings.create_salaries',
    component: () => import('@/views/savings/salaries/AddSalary.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/bills/create',
    name: 'savings.add_bills',
    component: () => import('@/views/savings/bills/AddBill.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/bills',
    name: 'savings.bills',
    component: () => import('@/views/savings/bills/BillsList.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/employees_payments/create',
    name: 'savings.add_employee_payment',
    component: () => import('@/views/savings/employee_pay/AddEmployeePay.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/employees_payments',
    name: 'savings.employees_payments',
    component: () => import('@/views/savings/employee_pay/EmployeesPayList.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/profits_commisions',
    name: 'savings.profits_commisions',
    component: () => import('@/views/savings/profits/ProfitsList.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/marketing/traffic',
    name: 'savings.marketing_traffic',
    component: () => import('@/views/savings/marketing_traffic/Traffic.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/prospects',
    name: 'savings.marketing_prospects',
    component: () => import('@/views/savings/marketing_prospects/Prospects.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/view/prospects/:id',
    name: 'savings.marketing_view_prospects:id',
    component: () => import('@/views/savings/marketing_prospects/ProspectsDetails.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/add/prospects',
    name: 'savings.add_marketing_prospects',
    component: () => import('@/views/savings/marketing_prospects/AddProspects.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/add/messages',
    name: 'savings.add_marketing_messages',
    component: () => import('@/views/savings/marketing_prospects/AddMessage.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/edit/messages/:id',
    name: 'savings.edit_marketing_messages:id',
    component: () => import('@/views/savings/marketing_prospects/EditMessage.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/send/ad_messages/:group_id/:message_id/:message_means/:start_date/:end_date',
    name: 'savings.edit_marketing_messages.:group_id.:message_id.:message_means.:start_date.:end_date',
    component: () => import('@/views/savings/marketing_prospects/SendAdMessageList.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/resources',
    name: 'savings.marketing_resources',
    component: () => import('@/views/savings/marketing_resources/Resources.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/marketing/add/resources/:key',
    name: 'savings.add_marketing_resources:key',
    component: () => import('@/views/savings/marketing_resources/AddResource.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/contact_us',
    name: 'savings.contact_us',
    component: () => import('@/views/savings/contact_us/ContactUs.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/chat/search_chat',
    name: 'chat.search_chat',
    component: () => import('@/views/chat/SearchChat.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/chat/chat/:id',
    name: 'chat.chat:id',
    component: () => import('@/views/chat/Chat.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/chat/chat_group/:list_ids/:group_name',
    name: 'chat.chat_group',
    component: () => import('@/views/chat/ChatGroup.vue'),
    meta: { requireLogin: true }
  },

  {
    path: '/savings/contact_us/reply/:id',
    name: 'savings.contact_us_reply:id',
    component: () => import('@/views/savings/contact_us/ContactUsChatReply.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/products',  // will contain all available orders and the topuptopup can choose a confirmed order from the manager and then he delivers them
    name: 'marketplace.products',  // orders can also be paid here and it automatically becomes ur order
    component: () => import('@/views/marketplace/products/ProductList.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/campaigns',
    name: 'marketplace.campaigns',
    component: () => import('@/views/marketplace/products/Campaigns.vue'),
    meta: { requireLogin: true }
  },
  {
    path: '/market_place/categories/add',
    name: 'marketplace.add_category',
    component: () => import('@/views/marketplace/products/AddCategory.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/products/add',
    name: 'marketplace.add_products',
    component: () => import('@/views/marketplace/products/AddProduct.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/products/showcase',
    name: 'marketplace.product_showcase',
    component: () => import('@/views/marketplace/products/ProductShowcase.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/products/detail/:id',
    name: 'marketplace.product_detail:id',
    component: () => import('@/views/marketplace/products/settings/ProductSettings.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/monitor/tasks',
    name: 'monitor.tasks',
    component: () => import('@/views/monitor/Tasks/Tasks.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/market_place/orders',
    name: 'marketplace.orders',
    component: () => import('@/views/marketplace/orders/OrdersList.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/orders/payment',
    name: 'marketplace.orders.payment',
    component: () => import('@/views/marketplace/orders/PaymentValidation.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/market_place/orders/settings/:id',
    name: 'marketplace.orders:id',
    component: () => import('@/views/marketplace/orders/settings/Order.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/orders/add/town',
    name: 'marketplace.add_order_town',
    component: () => import('@/views/marketplace/orders/AddShippingTown.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/orders/add/shipping_point',
    name: 'marketplace.add_order_shipping_point',
    component: () => import('@/views/marketplace/orders/AddShippingPoint.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/products/settings/:product_id',
    name: 'marketplace.product_settings:product_id',
    component: () => import('@/views/marketplace/products/settings/ProductSettings.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/transactions',  // view transactions (orders) only from his deliveries completed, pending delivery, cancelled by him
    name: 'marketplace.transactions',
    component: () => import('@/views/marketplace/transactions/TransactionsList.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/profits_commisions',  // view profits from his deliveries
    name: 'marketplace.profits_commisions',
    component: () => import('@/views/marketplace/profits/ProfitsList.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/faults',  // profits and commisions made by topup for the company through njangi
    name: 'marketplace.faults',
    component: () => import('@/views/marketplace/profits/Faults.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/faults/create',
    name: 'marketplace.create_fault',
    component: () => import('@/views/marketplace/profits/CreateFault.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/market_place/marketing/traffic',
    name: 'marketplace.marketing_traffic',
    component: () => import('@/views/marketplace/marketing_traffic/Traffic.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/marketing/prospects',
    name: 'marketplace.marketing_prospects',
    component: () => import('@/views/marketplace/marketing_prospects/Prospects.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/marketing/resources',
    name: 'marketplace.marketing_resources',
    component: () => import('@/views/marketplace/marketing_resources/Resources.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/contact_us',
    name: 'marketplace.contact_us',
    component: () => import('@/views/marketplace/contact_us/ContactUs.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/market_place/contact_us/reply/:id',
    name: 'marketplace.contact_us_reply:id',
    component: () => import('@/views/marketplace/contact_us/ContactUsChatReply.vue'), meta: {
      requireLogin: true
    }
  },


  {
    path: '/market_place/seller/applications',
    name: 'market_place.seller_applications',
    component: () => import('@/views/marketplace/seller/SellerApplications.vue'),
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/market_place/seller/management',
    name: 'market_place.seller_management',
    component: () => import('@/views/marketplace/seller/SellerManagement.vue'),
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/market_place/reseller/applications',
    name: 'market_place.reseller_applications',
    component: () => import('@/views/marketplace/reseller/ResellerApplications.vue'),
    meta: { requiresAuth: true, requiresManager: true },
  },
  {
    path: '/market_place/reseller/management',
    name: 'market_place.reseller_management',
    component: () => import('@/views/marketplace/reseller/ResellerManagement.vue'),
    meta: { requiresAuth: true, requiresManager: true },
  },

  {
    path: '/njangi/groups/pending',
    name: 'njangi.pending_groups',
    component: () => import('@/views/njangi/groups/PendingGroups.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/join/requests',
    name: 'njangi.join_requests',
    component: () => import('@/views/njangi/groups/Requests.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/njangi/accept/requests',
    name: 'njangi.accept_requests',
    component: () => import('@/views/njangi/groups/AcceptRequest.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/njangi/create/group',
    name: 'njangi.create_group',
    component: () => import('@/views/njangi/groups/SelectGroupType.vue'),
    meta: {
      requireLogin: true
    }
  },

  // Route pour créer un groupe Standard (Daily/Weekly/Monthly)
  {
    path: '/njangi/create/group/standard',
    name: 'njangi.create_group_standard',
    component: () => import('@/views/njangi/groups/CreateNjangi.vue'), // ✅ Votre composant existant
    meta: {
      requireLogin: true
    }
  },

  // Route pour créer un groupe Custom
  {
    path: '/njangi/create/group/custom',
    name: 'njangi.create_group_custom',
    component: () => import('@/views/njangi/groups/CreateCustomGroup.vue'),
    meta: {
      requireLogin: true
    }
  },



  {
    path: '/njangi/view/groups',
    name: 'njangi.view_groups',
    component: () => import('@/views/njangi/groups/ViewNjangiGroups.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/groups/edit/:id',
    name: 'njangi.edit_group',
    component: () => import('@/views/njangi/groups/EditNjangiGroup.vue'),
    meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/manage/groups',
    name: 'njangi.Manage_groups',
    component: () => import('@/views/njangi/groups/ManagerDashboard.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/collector-payment',
    name: 'njangi.collector_payment',
    component: () => import('@/views/njangi/groups/CollectorPayment.vue'),
    meta: {
      requireLogin: true
    }
  },


  {
    path: '/njangi/contribution_requests',
    name: 'njangi.contribution_requests',
    component: () => import('@/views/njangi/contribution/Requests.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/contribution_transactions',
    name: 'njangi.contribution_transactions',
    component: () => import('@/views/njangi/contribution/Transactions.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/make_contribution',
    name: 'njangi.make_contribution',
    component: () => import('@/views/njangi/contribution/MakeDeposit.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/njangi/marketing/traffic',
    name: 'njangi.marketing_traffic',
    component: () => import('@/views/njangi/marketing_traffic/Traffic.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/marketing/prospects',
    name: 'njangi.marketing_prospects',
    component: () => import('@/views/njangi/marketing_prospects/Prospects.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/marketing/resources',
    name: 'njangi.marketing_resources',
    component: () => import('@/views/njangi/marketing_resources/Resources.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/contact_us',
    name: 'njangi.contact_us',
    component: () => import('@/views/njangi/contact_us/ContactUs.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/njangi/contact_us/reply/:id',
    name: 'njangi.contact_us_reply:id',
    component: () => import('@/views/njangi/contact_us/ContactUsChatReply.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/profile/account-settings',
    name: 'profile-account-settings',
    component: () => import('@/views/authentication/account-settings/AccountSettings.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/Message'),
  },
  {
    path: '/savings/marketer_fee',
    name: 'savings.marketer_fee',
    component: () => import('@/views/savings/withdrawal/MarketerFee.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/manager/analytics',
    name: 'savings.manager_analytics',
    component: () => import('@/views/savings/manager/Analytics.vue'), meta: {
      requireLogin: true
    }
  },
  {
    path: '/savings/campaign-migration',
    name: 'savings.campaign_migration',
    component: () => import('@/views/savings/manager/CampaignMigration.vue'), meta: {
      requireLogin: true
    }
  },

  {
    path: '/savings/partners/list',
    name: 'manager.partners.list',
    component: () => import('@/views/savings/partners/PartnersList.vue'),
    meta: {
      title: 'Manager: Partners Management',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Partners', active: true }
      ]
    }
  },
  {
    path: '/savings/partners/detail/:id',
    name: 'manager.partners.detail',
    component: () => import('@/views/savings/partners/PartnerDetail.vue'),
    meta: {
      title: 'Manager: Partner Details',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Partners', to: '/savings/partners/list' },
        { text: 'Detail', active: true }
      ]
    }
  },
  {
    path: '/savings/topup/detail/:id',
    name: 'manager.topup.detail',
    component: () => import('@/views/savings/topups/TopupDetail.vue'),
    meta: {
      title: 'Manager: Top‑Up Account Details',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Top‑Up', to: '/savings/topup/list' },   // adapte le lien vers ta liste Top‑Up
        { text: 'Detail', active: true }
      ]
    }
  },

  {
    path: '/savings/clients/investments/list',
    name: 'manager.investments.list',
    component: () => import('@/views/savings/clients/investments/InvestmentsList.vue'),
    meta: {
      title: 'Manager: Investments Management',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Investments', active: true }
      ]
    }
  },
  {
    path: '/savings/clients/investments/detail/:investment_id',
    name: 'manager.investments.detail',
    component: () => import('@/views/savings/clients/investments/InvestmentDetail.vue'),
    meta: {
      title: 'Manager: Investment Details',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Investments', to: '/savings/clients/investments/list' },
        { text: 'Details', active: true }
      ],
      requireLogin: true
    }
  },
  // Validation des paiements

  {
    path: '/savings/clients/investments/validate',
    name: 'manager.investments.validate',
    component: () => import('@/views/savings/clients/investments/ValidatePayments.vue'),
    meta: {
      title: 'Manager: Validate Investment Payments',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Investments', to: '/manager/investments' },
        { text: 'Validate Payments', active: true }
      ]
    }
  },
  {
    path: '/savings/clients/investments/make-payment',
    name: 'manager.investments.make_payment',
    component: () => import('@/views/savings/clients/investments/MakePayment.vue'),
    meta: {
      title: 'Manager: Make Investment Payment',
      breadcrumb: [
        { text: 'Dashboard', to: '/manager' },
        { text: 'Investments', to: '/savings/clients/investments/list' },
        { text: 'Make Payment', active: true }
      ],
      requireLogin: true
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})



router.beforeEach((to, from, next) => {
  // to initialise authenticated
  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
    store.commit('initialiseStore')
  }

  if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {

    next({ name: 'login', query: { to: to.path } });
    store.commit('setSnackBarMessage', "Login is required: Please log into your account or request for the creation of one now.")
    store.commit('setSnackBarColor', "red darken-4")
    store.commit('activateSnackBar', true)
  } else {
    const token = store.state.token
    if (token) {
      axios.defaults.headers.common['Authorization'] = "Token " + token
    } else {
      axios.defaults.headers.common['Authorization'] = ""
    }
    console.log(to.path, from.path)
    next()
  }
})



export default router
